const COUNTRY_CODES = {
    // Country codes
    COUNTRY_CODE_ES: 'ES',
    COUNTRY_CODE_PT: 'PT',
    COUNTRY_CODE_NL: 'NL',
    COUNTRY_CODE_DE: 'DE',
    COUNTRY_CODE_FR: 'FR',
    COUNTRY_CODE_UA: 'UA',
  };

module.exports = COUNTRY_CODES;

  